// sof-search-predictive-toggle: control when the predictive-search panel
// is visible. Dawn's own JS tries to show the panel on focus / mount, which
// gives us a huge empty white box with a giant loading spinner. We override
// by adding/removing a .sof-active class on .sof-header-search keyed to
// whether the input has real typed content.
(function () {
  function wire(root) {
    const input = root.querySelector('.sof-search-input');
    if (!input) return;
    const update = () => {
      const hasContent = input.value && input.value.trim().length > 0;
      root.classList.toggle('sof-active', Boolean(hasContent));
    };
    input.addEventListener('input', update);
    input.addEventListener('focus', update);
    const mtoggle = root.closest('.sof-header-search') === root ? root.querySelector('.sof-search-mobile-toggle') : null;
    const wrapper = root.classList.contains('sof-header-search') ? root : root.closest('.sof-header-search');
    if (wrapper) {
      const btn = wrapper.querySelector('.sof-search-mobile-toggle');
      if (btn && !btn.dataset.sofWired) {
        btn.dataset.sofWired = '1';
        btn.addEventListener('click', () => {
          const opening = !wrapper.classList.contains('sof-open');
          wrapper.classList.toggle('sof-open', opening);
          btn.setAttribute('aria-expanded', String(opening));
          if (opening) setTimeout(() => input.focus(), 60);
        });
        input.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') { wrapper.classList.remove('sof-open'); btn.setAttribute('aria-expanded', 'false'); }
        });
      }
    }
    input.addEventListener('blur', () => {
      // Small delay so a click on a result can still register before we hide
      setTimeout(() => {
        if (!input.matches(':focus') && (!input.value || !input.value.trim())) {
          root.classList.remove('sof-active');
          const w = root.classList.contains('sof-header-search') ? root : root.closest('.sof-header-search');
          if (w) { w.classList.remove('sof-open'); const b = w.querySelector('.sof-search-mobile-toggle'); if (b) b.setAttribute('aria-expanded', 'false'); }
        }
      }, 150);
    });
    // Reset button (X) clears input then updates
    const reset = root.querySelector('.sof-search-reset');
    if (reset) {
      reset.addEventListener('click', () => {
        input.value = '';
        update();
      });
    }
    update();
  }

  function init() {
    document.querySelectorAll('.sof-header-search').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
